var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.23,12.043a12.2,12.2,0,0,0-1.411-.566,6.375,6.375,0,1,0-7.633,0A12.194,12.194,0,0,0,.061,20.565,2.848,2.848,0,0,0,2.845,24H14.391a.938.938,0,0,0,0-1.875H2.845a.953.953,0,0,1-.75-.357.979.979,0,0,1-.2-.821,10.358,10.358,0,0,1,9.855-8.2q.124,0,.249,0t.251,0a10.212,10.212,0,0,1,4.174.991.938.938,0,0,0,.8-1.693Zm-5-1.173-.229,0-.227,0a4.5,4.5,0,1,1,.456,0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.094 15.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.969,325.516h-2.578v-2.578a.938.938,0,0,0-1.875,0v2.578h-2.578a.938.938,0,0,0,0,1.875h2.578v2.578a.938.938,0,0,0,1.875,0v-2.578h2.578a.938.938,0,0,0,0-1.875Z",
    transform: "translate(-322 -322)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.0a7288fc2e53e073c50ab767820d7ace.svg";
export { ForwardRef as ReactComponent };